import api from './api';

export const getPendingSuspiciousActivity = () =>
  api.get('/auth/suspicious-activity');

export const respondToSuspiciousActivityAlert = ({ alert_id, response }) =>
  api.post('/auth/suspicious-activity/respond', { alert_id, response });

